import { lazy } from 'react';

export type { MapLine, MapPoint, ZeroMapProps, MapMarker, FeatureState } from './ZeroMap';

/**
 * The TomTom map, code-split: the SDK (~1.2 MB) and this module load only when
 * a map is actually rendered.
 */
export const LazyZeroMap = lazy(() => import('./ZeroMap'));
